import React from 'react';
import css from './index.module.scss';
import { Link as GatsbyLink } from 'gatsby';
import { NavLink } from '../../NavLink';
import { useLocation } from '@reach/router';
import { scrollToY } from '../../../utils';
import { Logo } from '../../Logo';

interface HeaderProps {}

export const Header = (props: HeaderProps) => {
  const location = useLocation();

  const handleScrollToIntro = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    if (location.pathname === '/') {
      event.preventDefault();
      scrollToY(0);
    }
  };

  return (
    <header className={css.container}>
      <div className={css.content}>
        {/* @TODO #18 When reaches main page hero title show full name @alk831  */}
        <GatsbyLink
          to="/"
          className={css.heading}
          onClick={handleScrollToIntro}
        >
          <Logo />
        </GatsbyLink>
        <nav className={css.navigation}>
          <GatsbyLink to="/">
            <NavLink
              className={css.link}
              isActive={location.pathname === '/'}
            >
              Home
            </NavLink>
          </GatsbyLink>
          <GatsbyLink to="/blog">
            <NavLink
              isActive={location.pathname.includes('/blog')}
              className={css.link}
            >
              Blog
            </NavLink>
          </GatsbyLink>
        </nav>
      </div>
    </header>
  );
};
